import React from 'react';

interface SliderProps {
  id: string;
  label: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  display: string;
  onChange: (value: number) => void;
}

// One labelled range input of the options, shared by the sound and voice cards
const Slider: React.FC<SliderProps> = ({ id, label, value, min = 0, max = 1, step = 0.05, disabled, display, onChange }) => (
  <div className="esc-slider">
    <label className="esc-slider__label" htmlFor={id}>{label}</label>
    <input
      id={id}
      type="range"
      className="esc-slider__input"
      min={min}
      max={max}
      step={step}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(Number(e.target.value))}
    />
    <output className="esc-slider__value" htmlFor={id}>{display}</output>
  </div>
);

export default Slider;
